import { mapState, mapGetters } from 'vuex'
import { debounce } from 'lodash-es'
import VueScroll from 'vue-scrollto'
//
import lang from '@data/lang.json'
import utils from '@/utils/utils'
//
import Pagination from '@/components/product-list/pagination/pagination'
import ProductCard from '@/components/product-card/product-card'

const ProductList = {
  // Components
  components: {
    'pagination': Pagination,
    'product-card': ProductCard
  },
  // Data
  data: () => {
    return {
      lastQueryString: utils.getSearchString(),
      lang: lang.ProductList
    }
  },
  props: [
    'categories',
    'contentId',
    'endpoint',
  ],
  // Computed
  computed: {
    ...mapState({
      settings: state => state.products.settings,
      products: state => state.products.products,
      status: state => state.products.status,
      pageIndex: function(state) {
        if (state.products.settings.pageCount < state.filters.pageIndex || state.filters.pageIndex < 1) {
          this.resetPagination()
          return 1
        } else {
          return state.filters.pageIndex
        }
      }
    }),
    hasProducts () {
      return Array.isArray(this.products) && this.products.length > 0
    },
    ...mapGetters('filters', {
      filterParams: 'filterParams'
    }),
  },
  // Methods
  methods: {
    getProducts(filterPayload) {
      if (!!filterPayload) {
        this.$store.dispatch('filters/setFilter', filterPayload)
      }

    // console.log('GET PRODUCTS PARAMS:', this.filterParams)
      this.$store.dispatch(
        'products/getProducts', {
          api: this.endpoint,
          params: this.filterParams
        }
      )
    },
    resetPagination() {
      bus.$emit('query_string_update')

      const payload = {
        type: 'pageIndex',
        value: 1
      }
      this.$store.dispatch('filters/setFilter', payload)

      const searchString = utils.getSearchString()
      const queryStringParams = new URLSearchParams(searchString)

      queryStringParams.set(payload.type, payload.value)

      const newURL = window.location.origin + window.location.pathname + '?' + queryStringParams.toString()
      window.history.pushState({path:newURL},'',newURL)
    },
    scrollToTop() {
      const productList = this.$refs.product_list
      VueScroll.scrollTo(productList, 400, {
        offset: -160
      })
    },
  },
  // Life cycle
  created () {
    if ((process.env.NODE_ENV !== 'production') || (typeof window !== 'undefined' && window.GPE_DEBUG === true)) {
      // eslint-disable-next-line no-console
      console.log('[product-list] created props', { categories: this.categories, contentId: this.contentId, endpoint: this.endpoint })
    }
    bus.$on('product_list_scroll', () => {
      this.scrollToTop()
    })

    // Debounce to stop fast clicking users to call api all the time
    bus.$on('query_string_update', debounce(() => {
      if (this.lastQueryString != utils.getSearchString()) {
      // console.log('UPDATE - FETCH PARAMS:', this.filterParams)

        // Change query string
        this.lastQueryString = utils.getSearchString()

        // Get new product data
        this.$store.dispatch(
          'products/getProducts', {
            api: this.endpoint,
            params: this.filterParams
          }
        )
      }
    }, 500))
  },
  mounted () {
    if ((process.env.NODE_ENV !== 'production') || (typeof window !== 'undefined' && window.GPE_DEBUG === true)) {
      // eslint-disable-next-line no-console
      console.log('[product-list] mounted: initial payload build')
    }
    // This check exists because BE wants to be able to input multiple categories as an array but if there only is one category they want to input it as a number
    const transformedCategoryValue = this.categories.length < 1
      ? [1]
      : isNaN(this.categories) === false
        ? [this.categories]
        : this.categories

    const payload = [{
      type: 'categories',
      value: transformedCategoryValue
    },
    {
      type: 'contentId',
      value: this.contentId.length < 1 ? 0 : this.contentId
    }]

    this.getProducts(payload)

    // Remove window debug exposure now that things work
  },
  watch: {
    products (val) {
      if ((process.env.NODE_ENV !== 'production') || (typeof window !== 'undefined' && window.GPE_DEBUG === true)) {
        // eslint-disable-next-line no-console
        console.log('[product-list] products updated', Array.isArray(val) ? val.length : null)
      }
    },
    status: {
      deep: true,
      handler (val) {
        if ((process.env.NODE_ENV !== 'production') || (typeof window !== 'undefined' && window.GPE_DEBUG === true)) {
          // eslint-disable-next-line no-console
          console.log('[product-list] status', val)
        }
      }
    }
  }
}

export default ProductList
